import QuizBanner from 'components/ads/landingPromos/QuizBanner'
import PromoForm from 'components/ads/landingPromos/PromoForm'
import { FC } from 'lib/component-utils'
import { useUserContext } from 'lib/context'
import { storage } from 'lib/local-storage'
import { useEffect, useState } from 'react'

const LandingPromoContainer: FC = () => {
  const ctx = useUserContext()
  const [selected, setSelected] = useState<'quiz' | 'promoForm' | null>(null)

  useEffect(() => {
    if (ctx.theme.hostType !== 'sellmonitor') return

    const quizEnabled: boolean = false

    if (quizEnabled) {
      if ((storage.get('landing:quiz:AdClosed:times') || 0) > 0) return
      setSelected('quiz')
    } else {
      setSelected('promoForm')
    }
  }, [ctx.theme.hostType])

  if (selected === 'quiz') {
    return <QuizBanner onDismiss={() => setSelected(null)} />
  }

  if (selected === 'promoForm') return <PromoForm />

  return null
}

export default LandingPromoContainer
